// extracted by mini-css-extract-plugin
export var container = "_3g-0";
export var error = "_3g-9";
export var label = "_3g-5";
export var light = "_3g-6";
export var md = "_3g-3";
export var sm = "_3g-2";
export var thin = "_3g-8";
export var thinBold = "_3g-7";
export var vertical = "_3g-4";
export var xs = "_3g-1";